// GA4 events (no personal data: no names, emails, phones, free text or query strings).
const PRIVATE = /^\/(login|gestione|operativo|flotta|clienti|contratti|impostazioni|portale|firma|dashboard|documenti|self-checkout|manage|q)(\/|$)/;
const SVC = { vespa125: "vespa", scooter125: "vespa", auto: "car", fiat500: "car", boat_private: "boat", boat_capri: "boat", boat_sg: "boat", transfer: "transfer", transfer_premium: "transfer", photo: "photoshoot" };
const BOOK = ["prenota ora", "book now", "réserver", "jetzt buchen", "reservar ahora", "забронировать", "reservar agora", "지금 예약"];
let checked = new Set(); // one check_availability per service per page view

export const track = (name, params = {}) => {
  if (!window.__gaOn || !window.gtag || PRIVATE.test(window.location.pathname)) return;
  window.gtag("event", name, params);
};

export function pageView() {
  const u = new URL(window.location.href);
  const lang = u.searchParams.get("lang");
  const loc = u.origin + u.pathname + (lang ? `?lang=${lang}` : "");
  checked = new Set();
  if (window.__gaOn && window.gtag) window.gtag("set", { page_location: loc }); // all later events (incl. automatic ones) use the URL without other query parameters
  track("page_view", { page_location: loc, page_title: document.title });
  const s = u.pathname.match(/^\/sito\/[^/]+\/s\/([^/]+)/);
  if (s) track("select_service", { service_key: s[1], service_group: SVC[s[1]] || "other" });
  const p = u.pathname.match(/^\/shop\/([^/]+)$/);
  if (p && p[1] !== "checkout") track("view_item", { items: [{ item_id: p[1] }] });
}

export function clickTrack(e) {
  const a = e.target.closest && e.target.closest("a,button");
  if (!a) return;
  const href = a.getAttribute("href") || "";
  const id = a.getAttribute("data-testid") || "";
  const at = window.location.pathname;
  if (/wa\.me|whatsapp\.com/.test(href)) track("whatsapp_click", { link_location: at });
  else if (href.startsWith("tel:")) track("phone_click", { link_location: at });
  else if (/^cinema-.+-cta$/.test(id) || id === "home-ferries-book-btn" || BOOK.includes((a.textContent || "").trim().toLowerCase()))
    track("book_now_click", { button_id: id || "book_now", link_url: href.split("?")[0] || undefined, link_location: at });
}

// Basic Consent Mode: granting starts GA (and counts the page being viewed once); revoking stops events and removes the _ga cookies.
export function consentUpdate(c) {
  if (!window.__ga4 || !window.__gaInit) return;
  if (c && c.stats) {
    if (window.__gaOn) return;
    window.__gaInit();
    pageView();
    return;
  }
  if (!window.__gaOn) return;
  window.gtag("consent", "update", { analytics_storage: "denied" });
  window.__gaOn = false;
  const host = window.location.hostname, parts = host.split(".");
  const domains = ["", host, `.${host}`, parts.length > 2 ? `.${parts.slice(-2).join(".")}` : `.${host}`];
  document.cookie.split(";").map((x) => x.split("=")[0].trim()).filter((n) => n.startsWith("_ga"))
    .forEach((n) => domains.forEach((d) => { document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ""}`; }));
}

export function leadFromResponse(r) {
  const url = r.config?.url || "";
  if (r.config?.method === "post" && /\/public\/pages\/[^/]+\/quote$/.test(url)) {
    let k;
    try { k = JSON.parse(r.config.data).service_key; } catch (e) { k = undefined; }
    if (k && !checked.has(k)) { checked.add(k); track("check_availability", { service_key: k, service_group: SVC[k] || "other" }); }
    return;
  }
  if (r.config?.method !== "post" || !/\/public\/pages\/[^/]+\/book$/.test(url)) return;
  let key;
  try { key = JSON.parse(r.config.data).service_key; } catch (e) { key = undefined; }
  track("generate_lead", { form_type: /guida/.test(url) ? "guide_booking" : "booking", service_key: key, service_group: SVC[key] || "other" });
}
